// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import SearchListComponent from '../../components/SearchListComponent';
import MainLayout from '../../layouts/MainLayout';
import { CardTypes, SearchCondition } from '../../types/Model';
import ErrorPage from '../ErrorPage';

import {
  useError,
  useIsFetching,
  useIsMoreFetching,
  useKeywords,
  useExamsList,
  useSearchExams,
  useSearchExamsKeywords,
  useHasMoreResults,
  useCommonKeywords
} from './hooks';

const SEARCH_LIMIT = 12;
const RECOMMENDATION_LIMIT = 6;

export const S = {
  ErrorPage: styled(ErrorPage)`
    flex-grow: 1;
  `
};

function ExamListPage(): JSX.Element {
  const isFetching = useIsFetching();
  const list = useExamsList();
  const error = useError();
  const [currentListFilter, setCurrentListFilter] = useState<SearchCondition>({ domainIds: [] });
  const [currentKeywordStream, setCurrentKeywordStream] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const searchExams = useSearchExams(SEARCH_LIMIT, currentPage, currentListFilter);
  const searchExamsKeywords = useSearchExamsKeywords(RECOMMENDATION_LIMIT, currentKeywordStream);
  const keywords = useKeywords(currentKeywordStream);
  const commonKeywords = useCommonKeywords(currentKeywordStream);
  const hasMoreResult = useHasMoreResults();
  const isMoreFetching = useIsMoreFetching();

  const handleUpdateListFilter = (nextListFilter: SearchCondition) => {
    setCurrentListFilter(nextListFilter);
    setCurrentPage(1);
  }

  const handleUpdatePage = () => {
    console.log({ hasMoreResult, currentPage })
    if (hasMoreResult) {
      setCurrentPage(currentPage + 1);
    }
  }

  useEffect(() => {
    searchExams();
  }, [currentPage, currentListFilter])

  useEffect(() => {
    searchExamsKeywords();
  }, [currentKeywordStream]);

  if (error) {
    console.log({ error })
    return (
      <MainLayout>
        <S.ErrorPage />
      </MainLayout>
    )
  }
  return (
    <MainLayout>
      <SearchListComponent
        isFetching={isFetching}
        isMoreFetching={isMoreFetching}
        list={list}
        type={CardTypes.EXAM}
        keywords={keywords}
        commonKeywords={commonKeywords}
        updateListFilter={handleUpdateListFilter}
        updateKeywordStream={setCurrentKeywordStream}
        updatePage={handleUpdatePage}
      />
    </MainLayout>
  )
}

export { ExamListPage as default };
